import React, { useState } from "react";
import { Menu as MenuIcon } from "@mui/icons-material";  
import { IconButton, MenuItem, Menu as MaterialMenu } from "@mui/material";  
import { Link } from "react-router-dom";
import Icon from "../../icon/Icon";

const Navbarmenu = () => {
  const [anchorEl, setAnchorEl] = useState(null); 
  const [activeMenu, setActiveMenu] = useState(null); 
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuAnchorEl(null);
    setActiveMenu(null); 
  };

  const handleSubmenuClick = (event, menu) => {
    if(activeMenu === menu) {
        handleSubmenuClose()
    }
    else{
        setSubmenuAnchorEl(event.currentTarget);
        setActiveMenu(menu); 
    }
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null);
    setActiveMenu(null);
  };

  console.log(submenuAnchorEl) 

  return (
    <div className="block lg:hidden">
      <IconButton onClick={handleMenuClick}>
        <MenuIcon color="primary" />
      </IconButton>

      <MaterialMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        className="block lg:hidden"
      >
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "marketplace")}
          className={`font-medium flex items-center gap-1 text-gray-200 ${activeMenu === "marketplace" && "!text-primary"}`}
        >
          Marketplace
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "marketplace" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "marketplace" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "organizeClasses")}
          className={`font-medium flex items-center gap-1 ${activeMenu === "organizeClasses" ? "!text-primary" : ""}`}
        >
          Organize Classes
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "organizeClasses" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "organizeClasses" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "organizefinance")}
          className={`font-medium flex items-center gap-1 ${activeMenu === "organizefinance" ? "!text-primary" : ""}`}
        >
          Organize Finance
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "organizefinance" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "organizefinance" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "health&fitness")}
          className={`font-medium flex items-center gap-1 ${activeMenu === "health&fitness" ? "!text-primary" : ""}`}
        >
          Health & Fitness
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "health&fitness" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "health&fitness" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "campus&community")}
          className={`font-medium flex items-center gap-1 ${activeMenu === "campus&community" ? "!text-primary" : ""}`}
        >
          Campus & Community
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "campus&community" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "campus&community" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "jobs")}
          className={`font-medium flex items-center gap-1 ${activeMenu === "jobs" ? "!text-primary" : ""}`}
        >
          Jobs
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "jobs" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "jobs" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "campusnews&alerts")}
          className={`font-medium flex items-center gap-1 ${activeMenu === "campusnews&alerts" ? "!text-primary" : ""}`}
        >
          Campus News & Alerts
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "campusnews&alerts" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "organizefinance" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem
          onClick={(e) => handleSubmenuClick(e, "askaicrow")}
          className={`font-medium flex items-center gap-1 ${activeMenu === "askaicrow" ? "!text-primary" : ""}`}
        >
          Ask The AI Crow
          <Icon name="arrowdown" layoutClass={`h-4 w-4 stroke-2 !text-primay ${activeMenu === "askaicrow" ? "rotate-180" : ""}`}/>
        </MenuItem>
        {activeMenu === "askaicrow" && ( 
          <>
            <MenuItem onClick={handleSubmenuClose}>Option 1</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 2</MenuItem>
            <MenuItem onClick={handleSubmenuClose}>Option 3</MenuItem>
          </>
        )}
        <MenuItem>
            <Link to="/signup" className="font-medium hover:text-primary flex items-center gap-1">
                <Icon name="signup" layoutClass="h-5 w-5 text-primary" />
                Signup
            </Link>
        </MenuItem>
        <MenuItem>
           <Link to="/login" className="font-medium hover:text-primary flex items-center gap-1">
                <Icon name="login" layoutClass="h-5 w-5 text-primary" />
                Login
            </Link>
        </MenuItem>
     </MaterialMenu>
    </div>
  );
};

export default Navbarmenu;
